<template>
  <form @submit.prevent="changePassword" method="post" class="user">
    <div class="form-group">
      <input
        v-model.trim="$v.form.password.$model"
        :class="{ 'is-invalid':$v.form.password.$error }"
        type="password"
        class="form-control"
        placeholder="Contraseña nueva"
      />
      <div class="invalid-feedback">
          <span v-if="!$v.form.password.$required">Este campo es requerido</span>
      </div>
    </div>
    <div class="form-group">
      <input
        v-model.trim="$v.form.confirmpass.$model"
        :class="{ 'is-invalid':$v.form.confirmpass.$error }"
        type="password"
        class="form-control"
        placeholder="Confirmar Contraseña"
      />
      <div class="invalid-feedback">
        <span v-if="!$v.form.confirmpass.sameAsPassword">Las contraseñas deben ser iguales</span>
      </div>
    </div>
    <button
      :disabled="onLoadForm"
      type="submit"
      class="btn btn-dark btn-block"
      @click="changePassword"
    >
      <clip-loader
        :class="{ 'd-none': !onLoadForm }"
        style="display: inline; margin-right: 10px"
        color="#fff"
        size="15px"
      ></clip-loader>
      Cambiar contraseña
    </button>
  </form>
</template>

<script>
import { required, sameAs, minLength } from 'vuelidate/lib/validators';
import axios from "axios";
export default {
  data() {
    return {
      form: {
        newpass: "",
        confirmpass: "",
        code: ""
      },
      onLoadForm: false,
      onErrorMsg: false,
      arrayErrors: [],
    };
  },
  created() {
      this.verificarCodigo();
  },
  validations: {
    form: {
      password: {
        required
      },
      confirmpass: {
        sameAsPassword: sameAs('password')
      }
    }
  },
  methods: {

    verificarCodigo() {
      let uri = window.location.href.split('?');
      if (uri.length == 2) {
          let vars = uri[1].split('&');
          let getVars = {};
          let tmp = '';
          vars.forEach(function(v){
            tmp = v.split('=');
            if(tmp.length == 2)
            getVars[tmp[0]] = tmp[1];
          });
          this.form.code = getVars.key;
      }
      axios.post("/ajax/code_verification", this.form).then((response) => {
        if(!response.data['valido']) {
          this.$swal.fire({
              icon: 'error',
              title: 'Token invalido',
              text: '¡Verifica el correo electrónico que enviamos!',
              confirmButtonColor: '#858796',
              confirmButtonText: 'Ok'
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.href = "/login";
              }
            })
        }
      });
    },
    changePassword() {
      this.$v.$touch()
      if(this.$v.$invalid){
          return this.submitStatus = "False";
      } else {
        this.onLoadForm = true;
        axios.post("/ajax/password", this.form).then((response) => {
          this.$swal.fire({
              icon: 'success',
              title: 'Contraseña cambiada',
              text: '¡Ahora ya tienes acceso a tu cuenta!',
              confirmButtonColor: '#858796',
              confirmButtonText: 'Ok'
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.href = "/login";
              }
            })
        });
      } 
    }
  },
};
</script>

<style lang="scss" scoped>
</style>